import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seller-account-transactions',
  templateUrl: './seller-account-transactions.component.html',
  styleUrls: ['./seller-account-transactions.component.css']
})
export class SellerAccountTransactionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
